var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    fillOpacity: 0.4,
    fill: "#000",
    cx: 25,
    cy: 25,
    r: 23.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.765 34.682-.388 1.616a74.114 74.114 0 0 1-2.785 1.07c-.693.246-1.498.368-2.415.368-1.409 0-2.504-.352-3.286-1.05-.78-.702-1.172-1.591-1.172-2.67 0-.417.029-.847.088-1.284.06-.439.154-.932.283-1.483L22.544 26c.13-.502.24-.979.327-1.429.09-.447.133-.859.133-1.23 0-.67-.136-1.138-.407-1.402-.271-.263-.788-.396-1.556-.396-.375 0-.762.061-1.156.18-.395.12-.733.234-1.017.341l.389-1.617a35.941 35.941 0 0 1 2.734-1.016c.87-.281 1.694-.422 2.472-.422 1.399 0 2.478.344 3.236 1.034.758.69 1.137 1.584 1.137 2.686 0 .228-.025.63-.078 1.204a8.195 8.195 0 0 1-.292 1.583l-1.447 5.226c-.119.42-.226.9-.319 1.44-.095.537-.141.947-.141 1.221 0 .694.152 1.168.456 1.42.306.252.834.377 1.584.377.352 0 .753-.063 1.198-.188.443-.125.767-.235.968-.331Zm.367-21.943c0 .91-.337 1.688-1.013 2.328-.675.642-1.488.963-2.439.963-.954 0-1.769-.321-2.451-.963-.681-.64-1.022-1.417-1.022-2.328 0-.909.34-1.688 1.022-2.335.681-.647 1.498-.97 2.451-.97.951 0 1.764.324 2.44.97.676.647 1.012 1.426 1.012 2.335Z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0aefd95e17ff3d5ca4d1c4c51e6ae88d.svg";
export { ForwardRef as ReactComponent };